/**
 * Konfiguration der dezenten Seiten-Hintergründe.
 *
 * ▶ EIGENES BILD / GIF / ICON HINTERLEGEN:
 *   1. Datei nach `public/backgrounds/` legen (z.B. `aktien.gif` oder `chart.png`).
 *   2. Hier beim passenden Schlüssel `src` auf `/backgrounds/<datei>` setzen.
 *      (Dateien in `public/` werden beim Build mitkopiert → nach dem Hinzufügen
 *       einer neuen Datei neu bauen/deployen.)
 *
 * Felder pro Eintrag:
 *   - src:      Pfad zur Datei (unter /backgrounds/...). Leer/null = kein Hintergrund.
 *   - opacity:  0..1, möglichst niedrig halten, damit es dezent bleibt.
 *   - size:     CSS background-size ('cover', 'contain' oder z.B. '720px').
 *   - position: CSS background-position ('center', 'top right', ...).
 *   - repeat:   CSS background-repeat ('no-repeat' für Fotos, 'repeat' für Kachelmuster).
 *
 * Tipp: Für ein einzelnes Foto/GIF eignet sich `size: 'cover'` + `repeat: 'no-repeat'`,
 * für ein nahtloses Muster (wie das mitgelieferte default.svg) `repeat: 'repeat'`.
 */

/** Mitgeliefertes, nahtlos kachelndes Platzhalter-Muster (dezente Finanz-Glyphen). */
const DEFAULT_BG = Object.freeze({
  src: '/backgrounds/default.svg',
  opacity: 0.05,
  size: '480px',
  position: 'center',
  repeat: 'repeat',
});

/** Hintergrund je Seiten-Schlüssel. Nicht gelistete Schlüssel fallen auf `default` zurück. */
export const BACKGROUNDS = Object.freeze({
  default: DEFAULT_BG,
  overview: { ...DEFAULT_BG, opacity: 0.06 }, // Portal-Übersicht
  aktien: { ...DEFAULT_BG, opacity: 0.045 }, // Aktienanalyse (Listen/Index)
  detail: { ...DEFAULT_BG, opacity: 0.04 }, // Aktie-Detailseite
});

/**
 * Liefert die Hintergrund-Konfiguration für einen Seiten-Schlüssel.
 * @param {string} name Schlüssel aus BACKGROUNDS (z.B. 'overview', 'aktien', 'detail').
 */
export const getBackground = (name) => BACKGROUNDS[name] || BACKGROUNDS.default;
